import { render, staticRenderFns } from "./SNCbyHygDa.vue?vue&type=template&id=c501a918&scoped=true"
import script from "./SNCbyHygDa.vue?vue&type=script&lang=ts"
export * from "./SNCbyHygDa.vue?vue&type=script&lang=ts"
import style0 from "./SNCbyHygDa.vue?vue&type=style&index=0&id=c501a918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c501a918",
  null
  
)

export default component.exports